import React, { useEffect } from 'react';
import Box from '@mui/material/Box';

function PrivacyPolicy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box component="main" className="bg-white min-h-screen font-sans text-gray-900">

      {/* Header / Title Section */}
      {/* Header / Title Section - Modern & Classy Redesign */}
      <div className="relative bg-[#523880] py-24 overflow-hidden">
        {/* Dynamic Background Elements */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#65308F] rounded-full blur-3xl opacity-50 mix-blend-screen"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-[#EE3788] rounded-full blur-3xl opacity-20 mix-blend-screen"></div>

        <div className="container relative z-10 mx-auto px-6 lg:px-40 max-w-7xl text-white">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full text-sm font-semibold mb-8 border border-white/10 shadow-lg">
            <span className="w-2 h-2 rounded-full bg-[#EE3788] animate-pulse"></span>
            <span className="tracking-wide uppercase text-[11px]">Legal & Compliance</span>
          </div>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl lg:text-6xl font-extrabold mb-6 tracking-tight leading-[1.1]">
                Privacy & <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#EE3788] to-[#F482C0]">
                  Cookies Policy
                </span>
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed font-medium max-w-2xl border-l-4 border-[#EE3788] pl-6">
                Transparency on how Oye Creators, operated by <span className="text-white font-bold">TTL Media Pvt. Ltd.</span>, handles your data.
              </p>
            </div>

            {/* Date Card */}
            <div className="bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 flex items-center min-w-[240px]">
              <div className="bg-[#EE3788] p-3 rounded-lg mr-4 text-white">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <span className="block text-gray-400 text-xs uppercase tracking-wider font-bold">Last Updated</span>
                <span className="block text-white font-bold text-lg">January 8, 2026</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 lg:px-40 max-w-7xl py-12">
        <div className="prose prose-lg max-w-none text-gray-800">

          <p className="mb-8 text-lg leading-relaxed text-gray-800">
            This Privacy & Cookies Policy explains how we collect, use, disclose, process, store, and protect information when you access or use our website, mobile application, and related services (collectively, the “Platform”).
            <br /><br />
            By using Oye Creators, you agree to the practices described in this Policy.
          </p>

          <hr className="my-12 border-gray-200" />

          {/* Section 1 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">1. Information We Collect</h2>
            <p className="mb-6 font-medium text-gray-800">We collect only the information necessary to operate a creator marketplace and facilitate brand-creator collaborations.</p>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="bg-white p-0">
                <h3 className="text-lg font-bold text-gray-900 mb-3">1.1 Personal Information</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2">
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Profile and account details</li>
                  <li>Social media handles (as provided by users)</li>
                  <li>Campaign-related and communication details</li>
                </ul>
              </div>

              <div className="bg-white p-0">
                <h3 className="text-lg font-bold text-gray-900 mb-3">1.2 Payment & Transaction Information</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2">
                  <li>Transaction confirmations</li>
                  <li>Settlement references</li>
                  <li>Billing records</li>
                </ul>
              </div>
            </div>

            <div className="my-8 p-5 bg-amber-50 border-l-4 border-amber-500 rounded-sm">
              <div className="flex items-start">
                <div className="text-amber-600 mr-3 mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div>
                  <strong className="block text-gray-900 text-lg mb-1 font-bold">Important Notice</strong>
                  <p className="text-gray-800 font-medium">
                    We do not store or process credit card, debit card, UPI, or bank account details on our servers. All payments are handled through third-party, PCI-DSS compliant payment gateways.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">1.3 User-Generated Content</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2">
                  <li>Uploaded videos, images, and other campaign deliverables</li>
                  <li>Chats, messages, and campaign communications</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">1.4 Device & Technical Data</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2">
                  <li>IP address</li>
                  <li>Device identifiers</li>
                  <li>Operating system version</li>
                  <li>App usage logs</li>
                  <li>Crash reports and diagnostics</li>
                </ul>
              </div>
            </div>

            <div className="mt-8">
              <h3 className="text-lg font-bold text-gray-900 mb-3">1.5 Optional Data</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2 mb-2">
                <li>Location data (if enabled by the user)</li>
                <li>Device permissions (camera, microphone, storage)</li>
              </ul>
              <p className="text-sm text-gray-500 italic pl-6">You may enable or disable optional data collection through your device settings at any time.</p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">2. How We Use Your Information</h2>
            <p className="mb-4 font-medium text-gray-800">We use collected information to:</p>
            <ul className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-8">
              {['Create and manage user accounts', 'Match creators with relevant campaigns', 'Facilitate communications between users', 'Process payments and settlements', 'Provide customer support', 'Improve platform performance and security', 'Conduct analytics and research', 'Comply with legal and regulatory obligations'].map((item, index) => (
                <li key={index} className="flex items-start text-gray-800">
                  <span className="mr-2 text-primary-500 font-bold">•</span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="p-5 bg-blue-50 border-l-4 border-blue-500 rounded-sm">
              <strong className="block text-gray-900 text-lg mb-1 font-bold">No Guaranteed Outcomes</strong>
              <p className="text-gray-800 font-medium">
                Data usage does not guarantee campaign selection, earnings, or outcomes.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">3. Sharing of Information</h2>
            <p className="mb-4 font-medium text-gray-800">We may share information only in the following circumstances:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-800 ml-2 mb-6">
              <li>With brands and advertisers for campaign execution</li>
              <li>With service providers (hosting, analytics, payment processing)</li>
              <li>To comply with legal obligations or lawful requests</li>
              <li>During mergers, acquisitions, or business transfers</li>
            </ul>
            <div className="inline-block p-4 bg-gray-100 border border-gray-200 rounded-sm">
              <p className="text-gray-900 font-bold flex items-center">
                <span className="mr-2 text-xl">🚫</span> We do not sell personal data to third parties.
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">4. User Rights & Controls (Google Policy 8.3 Compliant)</h2>
            <p className="mb-4 font-medium text-gray-800">You have the right to:</p>
            <div className="flex flex-wrap gap-4 mb-8">
              {['Access your personal data', 'Correct or update inaccurate information', 'Withdraw consent for optional data', 'Request deletion of your data'].map((right, idx) => (
                <div key={idx} className="bg-white px-4 py-2 border border-gray-300 rounded text-gray-800 font-semibold shadow-sm">
                  {right}
                </div>
              ))}
            </div>

            <div className="bg-gray-50 p-6 border border-gray-200 rounded-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4">4.1 Data Deletion Requests</h3>
              <p className="mb-4 text-gray-800">You may request deletion of your personal data by emailing:</p>
              <div className="ml-4 mb-4 space-y-1">
                <p className="text-gray-900"><strong>Email:</strong> <a href="mailto:privacy@oyecreators.com" className="text-primary-600 underline">privacy@oyecreators.com</a></p>
                <p className="text-gray-900"><strong>Subject:</strong> Data Deletion Request</p>
              </div>
              <p className="text-sm text-gray-600 border-t border-gray-300 pt-3 mt-3">Verified requests are processed within 30 days, except where data retention is required by law (e.g., financial or compliance records).</p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">5. Data Retention</h2>
            <p className="mb-4 font-medium text-gray-800">We retain data only for as long as necessary:</p>
            <div className="border border-gray-200 rounded-sm overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <tbody className="bg-white divide-y divide-gray-200">
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap bg-gray-50 font-bold text-gray-900 w-1/3">Account & profile data</td>
                    <td className="px-6 py-4 text-gray-800">Until account deletion is requested</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap bg-gray-50 font-bold text-gray-900">Campaign & transaction records</td>
                    <td className="px-6 py-4 text-gray-800">Up to 7 years for legal and accounting compliance</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap bg-gray-50 font-bold text-gray-900">Analytics & log data</td>
                    <td className="px-6 py-4 text-gray-800">Limited duration and anonymized where possible</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">6. Security Measures</h2>
            <p className="mb-4 font-medium text-gray-800">We implement reasonable technical and organizational safeguards including:</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
              {['Encryption of sensitive data', 'Secure servers and storage', 'Role-based access controls', 'Monitoring and abuse prevention measures'].map((item, i) => (
                <div key={i} className="bg-white p-4 border border-gray-300 text-center font-bold text-gray-800 rounded shadow-sm">
                  {item}
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 italic">Users are responsible for maintaining the confidentiality of their account credentials.</p>
          </section>

          {/* Section 7 */}
          <section className="mb-14">
            <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">7. App Permissions</h2>
            <p className="mb-6 font-medium text-gray-800">Our mobile application may request the following permissions only when necessary:</p>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { title: 'Camera', desc: 'For content uploads', icon: '📸' },
                { title: 'Microphone', desc: 'For recording content', icon: '🎤' },
                { title: 'Storage', desc: 'For uploads and downloads', icon: '💾' },
                { title: 'Location (optional)', desc: 'For discovery and relevance', icon: '📍' }
              ].map((perm, i) => (
                <div key={i} className="flex items-start p-4 border border-gray-200 rounded ">
                  <span className="text-2xl mr-4">{perm.icon}</span>
                  <div>
                    <strong className="block text-gray-900 font-bold">{perm.title}</strong>
                    <span className="text-gray-700">{perm.desc}</span>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-4 text-sm text-gray-600">Permissions can be managed or revoked through device settings.</p>
          </section>

          {/* Additional Sections */}
          <div className="space-y-12 mb-14">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">8. Cookies & Tracking Technologies</h2>
              <p className="text-gray-800 mb-2">We use cookies and similar technologies for:</p>
              <ul className="list-disc list-inside text-gray-800 mb-2 font-medium">
                <li>Session management</li>
                <li>Platform functionality</li>
                <li>Analytics and performance monitoring</li>
              </ul>
              <p className="text-sm text-gray-600">You may control cookies through your browser or device settings.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Children’s Privacy (Google-Critical)</h2>
              <p className="text-gray-800 mb-2">
                Oye Creators is intended only for users <span className="font-bold">aged 18 years and above</span>.
              </p>
              <p className="text-gray-800 font-medium">We do not knowingly collect or process data from individuals under 18.</p>
              <p className="text-sm text-red-600 font-bold mt-1">If such data is identified, it will be deleted promptly.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">10. International Data Transfers</h2>
              <p className="text-gray-800 font-medium leading-relaxed">
                Your information may be processed or stored outside your country of residence. Where such transfers occur, we implement appropriate safeguards to protect your data in accordance with applicable laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">11. Changes to This Policy</h2>
              <p className="text-gray-800 font-medium leading-relaxed">
                We may update this Privacy Policy from time to time. Material changes will be communicated through the website or application. Continued use of the Platform after updates constitutes acceptance of the revised Policy.
              </p>
            </section>
          </div>



        </div>
      </div>
    </Box>
  );
}

export default PrivacyPolicy;
